export const TOGGLE_TORCH_ERROR_POPUP = 'TOGGLE_TORCH_ERROR_POPUP'

export function displayTorchErrorPopupReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_TORCH_ERROR_POPUP:
            return action.payload
        default: return state
    }
}